import React, { useEffect, useState, useRef } from "react";
import "./CQProfessorAssignment.css";
import moment from "moment-timezone";
import { Modal } from "react-bootstrap";
import Spinner from "../../Spinner/Spinner";
import { useStopwatch } from "react-timer-hook";
import { PieChart } from "react-minimal-pie-chart";
import InnerHTML from "dangerously-set-html-content";
import { PDFExport } from "@progress/kendo-react-pdf";
import loadingIcon from "../../Spinner/loadingIcon.gif";
import { handleException } from "../../../app/util/util";
import CQProfessorAssignmentPopUp from "./CQProfessorAssignmentPopUp";
import {
  handleResponse,
  handleJwtTokenForKeppMeLoggedIn,
} from "../../../app/util/HOC";
import {
  Chart,
  ChartAxisDefaults,
  ChartSeries,
  ChartSeriesItem,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartValueAxis,
  ChartValueAxisItem,
  ChartTooltip,
} from "@progress/kendo-react-charts";
import QuizOptions from "../../ConnectedQuizStudent/CQStudentQuiz/QuizOptions";
import QuizResultPieChart from "../../ConnectedQuizStudent/CQStudentQuiz/QuizResultPieChart";
import { RenderAnswers } from "./RenderAnswer";
import {
  CHECKBOX,
  getQuestionStatus,
  MAX_SELECTION,
} from "../../ConnectedQuizStudent/CQStudentQuiz/utils";
import ConfirmDialog from "../../ConnectedQuizStudent/CQStudentQuiz/ConfirmDialog";
export default function CQProfessorAssignment(props) {
  var cqUserId = props.data.cqUserId,
    cqSemId = props.data.cqSemId,
    cqSemED = semEndDateTimeModification(props.data.cqSemED),
    cqSemSD = semEndDateTimeModification(props.data.cqSemSD),
    cqClassId = props.data.cqClassId,
    cqClassCode = props.data.cqClassCode,
    cqClassName = props.data.cqClassName,
    cqQuizSetId = props.data.cqQuizSetId,
    cqQuizId = props.data.cqQuizId,
    cqIdentifier = props.data.cqIdentifier,
    cqQuizVer = props.data.cqQuizVer,
    cqQuizName = props.data.cqQuizName;
  var excelRepoDateTime = new Date()
      .toLocaleString("en-US", { hour12: false })
      .replace(",", ""),
    excelRepoTimeZone = moment.tz(moment.tz.guess()).zoneAbbr();
  var newStudList = [];
  const regexForStripHTML = /(<([^>]+)>)/gi;
  const userVO = JSON.parse(localStorage.getItem("userVO"));
  const currentDate = moment(new Date()).format("YYYY-MM-DD HH:mm");
  const keepMeLogIn = localStorage.getItem("keepLoggedIn") ? "true" : "false";
  const quizSubmitDateTime = new Date()
    .toISOString()
    .slice(0, 19)
    .replace("T", " ");
  const authToken = userVO.apJwtAuthenticationToken
    ? userVO.apJwtAuthenticationToken
    : localStorage.getItem("apJwtAuthenticationToken");
  const resTabDownloadRef = useRef();
  const pdfExportComponent = useRef(null);
  const cqStudQuizPopUpBtnsRef = useRef(null);
  const [dateSE, setDateSE] = useState(false);
  const [quizBtn1, setQuizBtn1] = useState("");
  const [aqEndDate, setAqEndDate] = useState("");
  const [quizBtn2, setQuizBtn2] = useState(false);
  const [aqStartDate, setAqStartDate] = useState("");
  const [resTabOverall, setResTabOverall] = useState();
  const [resExcelDown, setResExcelDown] = useState(false);
  const [refreshChart, setRefreshChart] = useState(false);
  const [resTabStudList, setResTabStudList] = useState([]);
  const [lowestStudList, setLowestStudList] = useState([]);
  const [resTabDownBtn, setResTabDownBtn] = useState(false);
  const [simuTabActive, setSimuTabActive] = useState(false);
  function showRequiredDivs() {
    setQuizStatus(quizStatus);
  }
  const [resTabClassType, setResTabClassType] = useState("");
  const [resTabTopicList, setResTabTopicList] = useState([]);
  const [resTabQuestList, setResTabQuestList] = useState([]);
  const [resTabMaxNofStuds, setResTabMaxNofStuds] = useState(0);
  const [isSummQRLoading, setIsSummQRLoading] = useState(false);
  const [previewDataQuests, setPreviewDataQuests] = useState([]);
  const [isSummTabLoading, setIsSummTabLoading] = useState(false);
  const [showQuestionList, setShowQuestionList] = useState(false);
  const [quizClsDate, setQuizClsDate] = useState(props.data.cqQuizCD);
  const [quizRelDate, setQuizRelDate] = useState(props.data.cqQuizRD);
  const [quizEndDate, setQuizEndDate] = useState(props.data.cqQuizED);
  const [showQuizAssignment, setShowQuizAssignment] = useState(false);
  const [isProfAssignLoading, setIsProfAssignLoading] = useState(true);
  const [quizStatus, setQuizStatus] = useState(props.data.cqQuizStatus);
  const [resTabClassResultView, setResTabClassResultView] = useState("");
  const [quizStartDate, setQuizStartDate] = useState(props.data.cqQuizSD);
  const [resTabStudentResultView, setResTabStudentResultView] = useState();
  const [quizRelopt, setQuizRelopt] = useState(props.data.cqQuizReleaseOpt);
  const [showEditQuizAssignment, setShowEditQuizAssignment] = useState(false);
  const quizQuesAns = [];
  const [totalAnsQuests, setTotalAnsQuests] = useState();
  const [cqQuizAssigned, setCqQuizAssigned] = useState(
    props.data.cqQuizAssigned,
  );
  const [quizResultFlag, setQuizResultFlag] = useState(
    props.data.cqQuizResultFlag,
  );
  const [isResTabStudResultsLoading, setIsResTabStudResultsLoading] =
    useState(false);
  const { seconds, minutes, hours, pause, start, reset } = useStopwatch({
    autoStart: false,
  });
  const [resTabStudentScores, setResTabStudentScores] = useState({
    scoreCat: [],
    noOfStudent: [],
  });
  const [quizQuests, setQuizQuests] = useState([]);
  const [totalQuests, setTotalQuests] = useState();
  const [showQuizResult, setShowQuizResult] = useState(false);
  const [summQR, setSummQR] = useState();
  const [currQuest, setCurrQuest] = useState();
  const [totalUnAnsQuests, setTotalUnAnsQuests] = useState();
  const [totalQuizTime, setTotalQuizTime] = useState();
  const [submitQuizPopUp, setSubmitQuizPopUp] = useState(false);
  const [showQuizAssignmentProps, setShowQuizAssignmentProps] = useState({
    scheduledQuizName: "",
    scheduledQuizClass: "",
    scheduledQuizSemED: "",
    scheduledQuizSemSD: "",
    assignQuizBtn: "",
    assignQuizSD: "",
    assignQuizED: "",
    assignQuizRelopt: "",
    assignQuizResultFlag: "",
    assignQuizIdentifier: "",
    assignClassId: "",
    assignPID: "",
    assigSemId: "",
    assignQuizId: "",
    assignUserId: "",
  });
  const [showEditQuizAssignmentProps, setShowEditQuizAssignmentProps] =
    useState({
      scheduledQuizName: "",
      scheduledQuizClass: "",
      scheduledQuizSemED: "",
      scheduledQuizSemSD: "",
      assignQuizBtn: "",
      assignQuizSD: "",
      assignQuizED: "",
      assignQuizRelopt: "",
      assignQuizRelD: "",
      assignQuizCloseD: "",
      assignQuizResultFlag: "",
      assignQuizIdentifier: "",
      assignClassId: "",
      assignPID: "",
      assigSemId: "",
      assignQuizId: "",
      assignUserId: "",
    });
  const [previewTabActive, setPreviewTabActive] = useState(
    cqSemED < currentDate
      ? cqQuizAssigned === true
        ? false
        : true
      : quizStatus === "yet to schedule" ||
          quizStatus === "scheduled" ||
          (quizStatus === "active" && cqQuizAssigned === false)
        ? true
        : false,
  );
  const [resTabShown, setResTabShown] = useState(
    (cqSemED < currentDate && cqQuizAssigned === false) ||
      quizStatus === "yet to schedule" ||
      (quizStatus === "active" && cqQuizAssigned === false)
      ? false
      : true,
  );
  const [resTabActive, setResTabActive] = useState(
    cqSemED < currentDate
      ? cqQuizAssigned === true
        ? true
        : false
      : (quizStatus === "active" && cqQuizAssigned === true) ||
          quizStatus === "completed"
        ? true
        : false,
  );
  const getSessionVO = () => {
    return {
      appType: "web",
      deviceMacId: "",
      keepMeLoggedInFlag: keepMeLogIn,
      deviceOS: localStorage.getItem("deviceOS"),
      deviceType: localStorage.getItem("deviceType"),
      browserName: localStorage.getItem("browserName"),
      sessionAuthenticationToken: userVO.sessionAuthenticationToken,
    };
  };
  useEffect(() => {
    if (submitQuizPopUp) {
      cqStudQuizPopUpBtnsRef.current.focus();
    }
  }, [submitQuizPopUp]);
  const handleHideContactMe = () => {
    setSubmitQuizPopUp(false);
  };
  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (
        resTabDownBtn &&
        resTabDownloadRef.current &&
        !resTabDownloadRef.current.contains(e.target)
      ) {
        setResTabDownBtn(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [resTabDownBtn]);
  useEffect(() => {
    document.addEventListener("keydown", removeChartTooltip, false);
    return () => {
      document.removeEventListener("keydown", removeChartTooltip, false);
    };
  }, []);
  const removeChartTooltip = (e) => {
    if (e.key === "Escape") {
      const chartToolTipContent = document.getElementById(
        "chartToolTipContent",
      );
      if (
        chartToolTipContent &&
        chartToolTipContent.parentNode &&
        chartToolTipContent.parentNode.parentNode
      ) {
        chartToolTipContent.parentNode.parentNode.removeChild(
          chartToolTipContent.parentNode,
        );
      }
    }
  };
  const handleQuizStatus = (
    qStatus,
    qEndDate,
    qStartDate,
    qRelOpt,
    qRelesDate,
    qCloseDate,
    qAssigned,
  ) => {
    setQuizStatus(qStatus);
    setCqQuizAssigned(qAssigned);
    if (quizBtn1 === "End Quiz") {
      setQuizEndDate(qEndDate);
    } else if (quizBtn1 === "Assign to class") {
      setQuizEndDate(qEndDate);
      setQuizStartDate(qStartDate);
    }
    if (qRelOpt === "stud_sub") {
      setQuizResultFlag(true);
      setQuizEndDate(qEndDate);
      setQuizStartDate(qStartDate);
    } else {
      setQuizRelopt(qRelOpt);
      setQuizResultFlag(false);
      setQuizEndDate(qEndDate);
      setQuizStartDate(qStartDate);
    }
    if (qRelOpt === "date_range") {
      setQuizRelDate(qRelesDate);
      setQuizClsDate(qCloseDate);
      setQuizEndDate(qEndDate);
      setQuizStartDate(qStartDate);
    }
  };
  const defaultTooltipRender = ({ point }) => (
    <div
      id="chartToolTipContent"
      role="tooltip"
    >{`Number of Students: ${point.value}`}</div>
  );
  useEffect(() => {
    if (quizStatus === "yet to schedule") {
      setDateSE(false);
      setQuizBtn1("Assign to class");
      setQuizBtn2(false);
    } else if (quizStatus === "scheduled") {
      setDateSE(true);
      setQuizBtn2(true);
      setAqStartDate("Starts: " + quizStartDate);
      setAqEndDate("Ends: " + quizEndDate);
      setQuizBtn1("Cancel Quiz");
    } else if (quizStatus === "active") {
      if (cqQuizAssigned === false) {
        setDateSE(false);
        setQuizBtn1("Assign to class");
        setQuizBtn2(false);
      } else {
        setDateSE(true);
        setQuizBtn2(true);
        setAqStartDate("Assigned: " + quizStartDate);
        setAqEndDate("Ends: " + quizEndDate);
        setQuizBtn1("End Quiz");
      }
    } else if (quizStatus === "completed") {
      setDateSE(true);
      setQuizBtn2(false);
      setAqStartDate("Assigned: " + quizStartDate);
      setAqEndDate("Completed: " + quizEndDate);
      setQuizBtn1("Reopen Quiz");
    }
    props.handlebackApiRender();
  }, [quizStatus, quizEndDate, quizStartDate]);
  function fetchPreviewTabData() {
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        schoolId: userVO.schoolId,
        userRoleId: userVO.userRoleId,
        keepMeLoggedInFlag: keepMeLogIn,
        userActivityVO: {
          lastReadBookId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
        },
        sessionVO: getSessionVO(),
      },
      classVO: { cqClassId: cqClassId },
      quizModel: { identifier: cqIdentifier },
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    fetch(
      `${localStorage.getItem(
        "qpAPI",
      )}/manageProfessor/getCQPreviewByQuizIdentifier`,
      requestOptions,
    )
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data) {
          var qpQuestions = data.questionVOList.map((previQues) => {
            return { ...previQues, ques_expand_status: false };
          });
          setPreviewDataQuests(qpQuestions);
          if (resTabShown === false) {
            setIsProfAssignLoading(props.assignmentLoading);
            setIsProfAssignLoading(false);
          }
        }
      })
      .catch((error) => {
        if (resTabShown === false) {
          setIsProfAssignLoading(props.assignmentLoading);
          setIsProfAssignLoading(false);
        }
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  function fetchSimuTabData() {
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        schoolId: userVO.schoolId,
        userRoleId: userVO.userRoleId,
        keepMeLoggedInFlag: keepMeLogIn,
        userActivityVO: {
          lastReadBookId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
        },
        sessionVO: getSessionVO(),
      },
      classV: { classId: cqClassId },
      quizDetails: { answerMasked: true, identifier: cqIdentifier },
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    fetch(
      `${localStorage.getItem(
        "qpAPI",
      )}/quiz/api/V2/quizDetailsWithQuestionList/${cqClassId}`,
      requestOptions,
    )
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data) {
          setQuizQuests(data.questions);
          setTotalQuests(data.questions.length);
          setCurrQuest(
            data.currentQuestion === 0
              ? data.currentQuestion + 1
              : data.currentQuestion,
          );
          setTotalAnsQuests(data.totalAnswered);
          setTotalUnAnsQuests(data.questions.length - data.totalAnswered);
          setTotalQuizTime(data.totalTimeSpent);
          setIsSummTabLoading(false);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  function fetchSimuTabSubmit() {
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        schoolId: userVO.schoolId,
        userRoleId: userVO.userRoleId,
        keepMeLoggedInFlag: keepMeLogIn,
        userActivityVO: {
          lastReadBookId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
        },
        sessionVO: getSessionVO(),
      },
      classV: { classId: cqClassId },
      quizDetails: {
        identifier: cqIdentifier,
        totalAnswered: totalAnsQuests,
        numberOfQuestions: totalQuests,
        questionIdentifiers: quizQuesAns,
        completedDate: quizSubmitDateTime,
        totalTimeSpent: totalQuizTime + convertHMSToSeconds(),
      },
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    fetch(
      `${localStorage.getItem("qpAPI")}/manageProfessor/V2/Submit-Quiz`,
      requestOptions,
    )
      .then(handleResponse)
      .then((response) => response.text())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data === "Successfully Inserted Quiz") {
          fetchSimmuTabResult();
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  function fetchSimmuTabResult() {
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        schoolId: userVO.schoolId,
        userRoleId: userVO.userRoleId,
        keepMeLoggedInFlag: keepMeLogIn,
        userActivityVO: {
          lastReadBookId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
        },
        sessionVO: getSessionVO(),
      },
      classVO: { cqClassId: cqClassId },
      quizDetails: { identifier: cqIdentifier },
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    fetch(
      `${localStorage.getItem("qpAPI")}/manageProfessor/V2/getQuizResult`,
      requestOptions,
    )
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data) {
          setSummQR(data);
          setIsSummQRLoading(false);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  function fetchResultTabOverall() {
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastReadBookId: "",
          lastReadPageNum: "",
          cqClassId: cqClassId,
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          qpProductId: cqQuizSetId,
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
          qpQuizIdentifier: cqIdentifier,
          lastViewedCQSemesterId: cqSemId,
        },
        sessionVO: getSessionVO(),
      },
      cqClassVO: { cqClassId: cqClassId },
      qpQuizVO: { qpQuizIdentifier: cqIdentifier },
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/manageCQ/getOverallResultForClass`,
      requestOptions,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "true" && data.cqResultVO) {
          setResTabOverall(data.cqResultVO);
          setResTabClassType(data.cqClassVO.cqClassType);
          fetchResultTabClass(data.cqClassVO.cqClassType);
        } else if (data.wkErrorCode) {
          handleException(data);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  function fetchResultTabClass(classType) {
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        schoolId: userVO.schoolId,
        userRoleId: userVO.userRoleId,
        keepMeLoggedInFlag: keepMeLogIn,
        userActivityVO: {
          lastReadBookId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
        },
        sessionVO: getSessionVO(),
      },
      classVO: { cqClassId: cqClassId },
      quizVO: { qpQuizIdentifier: cqIdentifier },
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    fetch(
      `${localStorage.getItem(
        "qpAPI",
      )}/manageProfessor/V2/getTopicResultsForClass`,
      requestOptions,
    )
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data) {
          if (data.topicVOList.length > 0 && data.questionVOList.length > 0) {
            var class_topic_list = data.topicVOList.map((topicList) => {
              topicList.associatedQuestionVOList =
                topicList.associatedQuestionVOList.map((topicListQues) => {
                  return { ...topicListQues, topicQues_expand_status: false };
                });
              return { ...topicList, topic_expand_status: false };
            });
            setResTabTopicList(class_topic_list);
            var question_list = data.questionVOList.map((orderQuesList) => {
              return { ...orderQuesList, orderQues_expand_status: false };
            });
            setResTabQuestList(question_list);
          }
          setResTabClassResultView(data.userSettingsVO.cqResultDisplayOption);
          fetchResultTabStudent(classType);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  function updateClassResultView(selectedView) {
    setRefreshChart(false);
    setResTabClassResultView(selectedView);
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastReadBookId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
        },
        sessionVO: getSessionVO(),
      },
      userSettingsVO: { cqResultDisplayOption: selectedView },
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/manageCQ/updateCQResultView`,
      requestOptions,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "false" && data.wkErrorCode) {
          handleException(data);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  function fetchResultTabStudent(classType) {
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        keepMeLoggedInFlag: keepMeLogIn,
        userActivityVO: {
          lastReadBookId: "",
          lastReadPageNum: "",
          cqClassId: cqClassId,
          qpProductId: cqQuizId,
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
          qpQuizIdentifier: cqIdentifier,
          lastViewedCQSemesterId: cqSemId,
        },
        sessionVO: getSessionVO(),
      },
      classVO: { cqClassId: cqClassId },
      quizVO: { qpQuizIdentifier: cqIdentifier },
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    fetch(
      `${localStorage.getItem("qpAPI")}/manageProfessor/V2/getAllStudentsScore`,
      requestOptions,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.cqResultVOList) {
          var cqStudResultList = Array.isArray(data.cqResultVOList)
            ? data.cqResultVOList
            : [data.cqResultVOList];
          var studResult_list = cqStudResultList.map((studResult) => {
            return { ...studResult, studTopic_expand_status: false };
          });
          setLowestStudList(studResult_list);
          setResTabStudList(studResult_list);
          handleOverallPerformanceGraph(studResult_list);
          fetchResTabStudResView(studResult_list, classType);
        }
        setIsProfAssignLoading(props.assignmentLoading);
        setIsProfAssignLoading(false);
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  function fetchResTabStudResView(studResultList, classType) {
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        schoolId: userVO.schoolId,
        userRoleId: userVO.userRoleId,
        keepMeLoggedInFlag: keepMeLogIn,
        userActivityVO: {
          lastReadBookId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
        },
        sessionVO: getSessionVO(),
      },
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    fetch(
      `${localStorage.getItem("qpAPI")}/manageProfessor/getCQStudentResultView`,
      requestOptions,
    )
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data) {
          setResTabStudentResultView(data.CQStudentResultView);
          handleStudResultSort(
            data.CQStudentResultView,
            studResultList,
            classType,
          );
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  function updateStudentResultView(selectedView) {
    var reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        schoolId: userVO.schoolId,
        userRoleId: userVO.userRoleId,
        keepMeLoggedInFlag: keepMeLogIn,
        userActivityVO: {
          lastReadBookId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
        },
        sessionVO: getSessionVO(),
      },
      userSettingsVO: { cqStudentResultDisplayOption: selectedView },
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    fetch(
      `${localStorage.getItem(
        "qpAPI",
      )}/manageProfessor/updateCQStudentResultView`,
      requestOptions,
    )
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  useEffect(() => {
    document.title = `${cqQuizName} | ${cqClassName} | Connected Quizzing`;
    showRequiredDivs();
    fetchPreviewTabData();
    fetchSimuTabData();
    if (resTabShown === true) {
      pause();
      fetchResultTabOverall();
    }
  }, []);
  function semEndDateTimeModification(valchk) {
    var estTime = moment.tz(valchk, "America/New_York");
    var t = estTime.clone().tz(moment.tz.guess());
    var splittingTim = t.format().split("T");
    var timeCHk = splittingTim[1].split(":");
    t = splittingTim[0];
    var time = timeCHk[0] + ":" + timeCHk[1];
    return t + " " + time;
  }
  function semEndDateTimeConversion(valchk) {
    var estTime = moment.tz(valchk, "America/New_York");
    var t = estTime.clone().tz(moment.tz.guess());
    var afterFormatDT = moment(t).format("MMMM DD, YYYY - hh:mm A z");
    var modificationData = afterFormatDT.replace("-", "at");
    return modificationData;
  }
  function dateTimeModification(beforeFormatDT) {
    var afterFDTZone = moment.tz.guess(),
      afterFDT = moment.utc(beforeFormatDT).clone().tz(afterFDTZone),
      afterFormatDT = moment(afterFDT).format("MMMM DD, YYYY - hh:mm A z");
    return afterFormatDT.replace("-", "at");
  }
  function studSubmitDateTimeModification(beforeFormatDT) {
    var afterFDTZone = moment.tz.guess(),
      afterFDT = moment.utc(beforeFormatDT).clone().tz(afterFDTZone),
      afterFormatDT = moment(afterFDT).format("MMM DD, YYYY - hh:mm A z");
    return afterFormatDT.replace("-", "at");
  }
  function onClickAssignmentProps(e) {
    setShowQuizAssignment(true);
    setShowQuizAssignmentProps({
      scheduledQuizName: cqQuizName,
      scheduledQuizClass: cqClassName,
      scheduledQuizSemED: semEndDateTimeConversion(props.data.cqSemED),
      scheduledQuizSemSD: semEndDateTimeConversion(props.data.cqSemSD),
      assignQuizBtn: e.target.innerText,
      assignQuizSD: quizStartDate,
      assignQuizED: quizEndDate,
      assignQuizRelopt: quizRelopt,
      assignQuizResultFlag: quizResultFlag,
      assignQuizIdentifier: cqIdentifier,
      assignClassId: cqClassId,
      assignPID: cqQuizSetId,
      assigSemId: cqSemId,
      assignQuizId: cqQuizId,
      assignUserId: cqUserId,
    });
  }
  function onClickEditAssignmentProps() {
    setShowEditQuizAssignment(true);
    setShowEditQuizAssignmentProps({
      scheduledQuizName: cqQuizName,
      scheduledQuizClass: cqClassName,
      scheduledQuizSemED: semEndDateTimeConversion(props.data.cqSemED),
      scheduledQuizSemSD: semEndDateTimeConversion(props.data.cqSemSD),
      assignQuizBtn: "Edit " + quizStatus + " assignment",
      assignQuizSD: quizStartDate,
      assignQuizED: quizEndDate,
      assignQuizRelD: quizRelDate,
      assignQuizCloseD: quizClsDate,
      assignQuizRelopt: quizRelopt,
      assignQuizResultFlag: quizResultFlag,
      assignQuizIdentifier: cqIdentifier,
      assignClassId: cqClassId,
      assignPID: cqQuizSetId,
      assigSemId: cqSemId,
      assignQuizId: cqQuizId,
      assignUserId: cqUserId,
    });
  }
  function handlePreviewTab() {
    pause();
    setPreviewTabActive(true);
    setSimuTabActive(false);
    setResTabActive(false);
  }
  function handlePrevTabExpCollpAll(quesExpandSt) {
    const newQuesExpandState = previewDataQuests.map((previQues) => {
      if (quesExpandSt === true) {
        return { ...previQues, ques_expand_status: true };
      } else {
        return { ...previQues, ques_expand_status: false };
      }
    });
    setPreviewDataQuests(newQuesExpandState);
  }
  function handlePrevTabExpCollpQues(quesNo, quesExpandSt) {
    const newQuesExpandState = previewDataQuests.map((previQues) => {
      if (previQues.questionOrder === quesNo) {
        return { ...previQues, ques_expand_status: quesExpandSt };
      }
      return previQues;
    });
    setPreviewDataQuests(newQuesExpandState);
  }
  function handleStudSimuTab() {
    setShowQuizResult(false);
    setIsSummTabLoading(true);
    fetchSimuTabData();
    setPreviewTabActive(false);
    setSimuTabActive(true);
    setResTabActive(false);
    reset();
  }
  function convertSecondsToHMS(value) {
    const sec = parseInt(value, 10);
    let hrs = Math.floor(sec / 3600);
    let mins = Math.floor((sec - hrs * 3600) / 60);
    let secs = sec - hrs * 3600 - mins * 60;
    if (mins < 10) {
      mins = "0" + mins;
    }
    if (secs < 10) {
      secs = "0" + secs;
    }
    return hrs + "h " + mins + "m " + secs + "s";
  }
  function convertHMSToSeconds() {
    return hours * 3600 + minutes * 60 + seconds;
  }
  function handleSaveForLater() {
    let eachQuesTime = 0,
      currQuesNo = 0,
      quesIndex = currQuest - 1;
    quizQuests.map((ques) => {
      if (quesIndex === currQuest - 1) {
        while (currQuesNo < totalQuests) {
          eachQuesTime += quizQuests[currQuesNo].timeSpent;
          currQuesNo += 1;
        }
        quizQuests[quesIndex].timeSpent += Math.abs(
          totalQuizTime + convertHMSToSeconds() - eachQuesTime,
        );
      }
      quesIndex += 1;
      var newSetQuizQues = {
        SelectedAnswerList: ques.SelectedAnswerList,
        identifier: ques.question_identifier,
        timeSpent: ques.timeSpent,
      };
      return quizQuesAns.push(newSetQuizQues);
    });
  }
  function navigateToQuestion(ques, nextQuestionNumber) {
    setCurrQuest(nextQuestionNumber);
    handlePrevNxtBtn();
  }
  const [dialog, setDialog] = useState({
    open: false,
    title: "",
    text: "",
    buttons: [],
  });
  const showDialog = (ques, nextQuestionNumber) => {
    setDialog({
      open: true,
      title: "Answer Incomplete",
      text: "You have selected only one response, and the instructions ask you to select two. Are you sure you want to move on? Select Cancel to return. Select OK to continue",
      buttons: [
        {
          label: "Cancel",
          action: () => setDialog((prev) => ({ ...prev, open: false })),
        },
        {
          label: "OK",
          action: () => [
            setDialog((prev) => ({ ...prev, open: false })),
            navigateToQuestion(ques, nextQuestionNumber),
          ],
        },
      ],
    });
  };
  function handleNavigation(ques, direction) {
    const nextQuestionNumber =
      direction === "next" ? currQuest + 1 : currQuest - 1;
    if (
      ques.itemTypeName === CHECKBOX &&
      ques.SelectedAnswerList.length > 0 &&
      ques.SelectedAnswerList.length < MAX_SELECTION
    ) {
      showDialog(ques, nextQuestionNumber);
    } else {
      setCurrQuest(nextQuestionNumber);
      handlePrevNxtBtn();
    }
  }
  function handleNextUnAnsw() {
    for (var i = 0; i < quizQuests.length; i++) {
      if (quizQuests[i].SelectedAnswerList.length === 0) {
        setCurrQuest(quizQuests[i].ordinal_number);
        break;
      }
    }
  }
  //   function handleSelOption() {
  //     var count = 0;
  //     quizQuests.map((ques) => {
  //       if (ques.SelectedAnswerList.length !== 0) {
  //         return (count += 1);
  //       }
  //     });
  //     setTotalAnsQuests(count);
  //     setTotalUnAnsQuests(totalQuests - count);
  //   }
  const handleSelOption = () => {
    let answeredCount = 0;

    quizQuests.forEach((ques) => {
      const ans = ques.SelectedAnswerList;
      const isAnswered = Array.isArray(ans) && ans.length > 0;

      if (isAnswered) {
        answeredCount += 1;
      }
    });
    setTotalAnsQuests(answeredCount);
    setTotalUnAnsQuests(totalQuests - answeredCount);
  };

  function handlePrevNxtBtn() {
    handleSaveForLater();
  }
  function dateTimeConversion(beforeFormatDateTime) {
    var afterFormatDateTime = dateTimeModification(beforeFormatDateTime);
    if (afterFormatDateTime.includes("AM")) {
      afterFormatDateTime = afterFormatDateTime.replace("AM", "a.m.");
    } else {
      afterFormatDateTime = afterFormatDateTime.replace("PM", "p.m.");
    }
    return afterFormatDateTime.split("at");
  }

  function handleSubmitQuiz() {
    setSubmitQuizPopUp(false);
    setShowQuizResult(true);
    setIsSummQRLoading(true);
    let eachQuesTime = 0,
      currQuesNo = 0,
      quesIndex = currQuest - 1;
    if (quizQuesAns.length === 0) {
      quizQuests.map((ques) => {
        if (quesIndex === currQuest - 1) {
          while (currQuesNo < totalQuests) {
            eachQuesTime += quizQuests[currQuesNo].timeSpent;
            currQuesNo += 1;
          }
          quizQuests[quesIndex].timeSpent += Math.abs(
            totalQuizTime + convertHMSToSeconds() - eachQuesTime,
          );
        }
        quesIndex += 1;
        var newSetQuizQues = {
          SelectedAnswerList: ques.SelectedAnswerList,
          identifier: ques.question_identifier,
          timeSpent: ques.timeSpent,
        };
        return quizQuesAns.push(newSetQuizQues);
      });
    }
    fetchSimuTabSubmit();
  }
  function handleViewResTab() {
    pause();
    setPreviewTabActive(false);
    setSimuTabActive(false);
    setResTabActive(true);
  }
  function handleOverallPerformanceGraph(studResult_list) {
    var scoreCat1 = 0,
      scoreCat2 = 0,
      scoreCat3 = 0,
      scoreCat4 = 0,
      scoreCat5 = 0,
      scoreCat6 = 0,
      scoreCat7 = 0,
      scoreCat8 = 0,
      scoreCat9 = 0,
      scoreCat10 = 0;
    if (studResult_list.length > 0) {
      studResult_list.map((studData) => {
        if (studData.instanceId !== 0) {
          var valScore = Math.round(studData.score);
          if (valScore >= 0 && valScore <= 9) {
            scoreCat1++;
          } else if (valScore >= 10 && valScore <= 19) {
            scoreCat2++;
          } else if (valScore >= 20 && valScore <= 29) {
            scoreCat3++;
          } else if (valScore >= 30 && valScore <= 39) {
            scoreCat4++;
          } else if (valScore >= 40 && valScore <= 49) {
            scoreCat5++;
          } else if (valScore >= 50 && valScore <= 59) {
            scoreCat6++;
          } else if (valScore >= 60 && valScore <= 69) {
            scoreCat7++;
          } else if (valScore >= 70 && valScore <= 79) {
            scoreCat8++;
          } else if (valScore >= 80 && valScore <= 89) {
            scoreCat9++;
          } else if (valScore >= 90 && valScore <= 100) {
            scoreCat10++;
          }
        }
      });
      var maxNoOfStudents = Math.max(
        scoreCat1,
        scoreCat2,
        scoreCat3,
        scoreCat4,
        scoreCat5,
        scoreCat6,
        scoreCat7,
        scoreCat8,
        scoreCat9,
        scoreCat10,
      );
      setResTabStudentScores({
        scoreCat: [
          "0-9%",
          "10-19%",
          "20-29%",
          "30-39%",
          "40-49%",
          "50-59%",
          "60-69%",
          "70-79%",
          "80-89%",
          "90-100%",
        ],
        noOfStudent: [
          scoreCat1,
          scoreCat2,
          scoreCat3,
          scoreCat4,
          scoreCat5,
          scoreCat6,
          scoreCat7,
          scoreCat8,
          scoreCat9,
          scoreCat10,
        ],
      });
      setResTabMaxNofStuds(
        maxNoOfStudents <= 5 ? 5 : Math.ceil(maxNoOfStudents / 5) * 5,
      );
      setRefreshChart(true);
    }
  }
  const handleChartRefresh = (chartOptions, themeOptions, chartInstance) => {
    if (refreshChart) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  };
  function handleTopicListExpand(topicValue, topicExpandSt) {
    setRefreshChart(false);
    const newTopicList = resTabTopicList.map((topicData) => {
      if (topicData.value === topicValue) {
        return { ...topicData, topic_expand_status: topicExpandSt };
      }
      return topicData;
    });
    setResTabTopicList(newTopicList);
  }
  function handleTopicQuesListExpand(topicValue, quesNo, quesExpandSt) {
    var newTopicQuesState = resTabTopicList.map((topicData) => {
      if (topicData.value === topicValue) {
        topicData.associatedQuestionVOList =
          topicData.associatedQuestionVOList.map((topicListQues) => {
            if (topicListQues.ordinalNumber === quesNo) {
              return {
                ...topicListQues,
                topicQues_expand_status: quesExpandSt,
              };
            }
            return topicListQues;
          });
      }
      return topicData;
    });
    setResTabTopicList(newTopicQuesState);
  }
  function handleQuesListQuesExpand(quesNo, quesExpandSt) {
    setRefreshChart(false);
    const newQuesExpandState = resTabQuestList.map((quesListQues) => {
      if (quesListQues.ordinalNumber === quesNo) {
        return { ...quesListQues, orderQues_expand_status: quesExpandSt };
      }
      return quesListQues;
    });
    setResTabQuestList(newQuesExpandState);
  }
  function handleStudResultSort(selectedView, selectedList, classType) {
    setRefreshChart(false);
    let studResList = selectedList ? selectedList : resTabStudList;
    if (selectedView === "lowestPerformance") {
      setLowestStudList([...studResList].sort());
    } else if (selectedView === "highestPerformance") {
      setLowestStudList([...studResList].reverse());
    } else {
      let cqClassType = classType ? classType : resTabClassType;
      if (cqClassType === "anonymous") {
        setLowestStudList(
          [...studResList].sort((stud1, stud2) =>
            stud1.firstName.localeCompare(stud2.firstName),
          ),
        );
      } else {
        setLowestStudList(
          [...studResList].sort((stud1, stud2) =>
            stud1.lastName.localeCompare(stud2.lastName),
          ),
        );
      }
    }
  }
  function handleUpdateStudResView(selectedView) {
    setResTabStudentResultView(selectedView);
    handleStudResultSort(selectedView);
    updateStudentResultView(selectedView);
  }
  function handleStudResultExpand(studUserId, studExpandSt) {
    setRefreshChart(false);
    newStudList = lowestStudList.map((studData) => {
      if (studData.userId === studUserId) {
        return { ...studData, studTopic_expand_status: studExpandSt };
      }
      return studData;
    });
    setLowestStudList(newStudList);
  }
  function downloadQuizPreviewPdf() {
    handlePrevTabExpCollpAll(true);
    setTimeout(() => {
      if (pdfExportComponent.current) {
        pdfExportComponent.current.save();
      }
    }, 500);
    setTimeout(() => {
      handlePrevTabExpCollpAll(false);
    }, 2000);
  }
  function quizPreviewReportTemplate() {
    var userEmail = userVO.email,
      fname = userVO.firstName,
      lname = userVO.lastName;
    var date = new Date().toJSON().slice(0, 10).split("-");
    var todayDt = date[1] + "/" + date[2] + "/" + date[0];
    var prevFooterCont =
      "Connected Quizzing document produced exclusively for " +
      fname +
      " " +
      lname +
      " (" +
      userEmail +
      ") on " +
      todayDt +
      ".";
    return (
      <div className="cqProfPdfTempl">
        <div>
          <img
            className="cqProfPdfTemplWaterMark"
            src="/cc/images/CQ_pdfWaterMark.png"
            alt=""
          ></img>
        </div>
        <div className="col-12 no-padding cqProfPdfTemplHeaderSec">
          <div className="col-6 cqProfPdfTemplHeaderImg1">
            <img
              style={{ width: "450px" }}
              src="/cc/images/CC_blackLogo.png"
              alt=""
            ></img>
          </div>
          <div className="col-4 cqProfPdfTemplHeaderImg2">
            <img
              style={{ width: "250px" }}
              src="/cc/images/CQ_logo_grey_screen.png"
              alt=""
            ></img>
          </div>
        </div>
        <div className="cqProfPdfTemplFooterSec">
          <table className="cqProfPdfTemplFooter">
            <tr>
              <td colSpan="2">{prevFooterCont}</td>
            </tr>
            <tr>
              <td colSpan="2">Redistribution is prohibited.</td>
            </tr>
            <tr>
              <td>
                <span> © {new Date().getFullYear()} Aspen Publishing</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    );
  }
  function downloadQuizResultPdf() {
    if (pdfExportComponent.current) {
      pdfExportComponent.current.save();
    }
  }
  function quizResultReportTemplate() {
    return (
      <div className="cqProfPdfTempl">
        <div className="col-12 no-padding cqProfPdfTemplHeaderSec">
          <div className="col-6 cqProfPdfTemplHeaderImg1">
            <img
              style={{ width: "450px" }}
              src="/cc/images/CC_blackLogo.png"
              alt=""
            ></img>
          </div>
          <div className="col-4 cqProfPdfTemplHeaderImg2">
            <img
              style={{ width: "250px" }}
              src="/cc/images/CQ_logo_grey_screen.png"
              alt=""
            ></img>
          </div>
        </div>
      </div>
    );
  }
  function downloadQuizResultExcel() {
    setResExcelDown(true);
    var cqProfQuNa = document.getElementById("cqProfQN").innerText;
    if (Number(resTabOverall.completedCount) === 0) {
      alert(
        "None of the students had submitted there quiz, " +
          "Please try any other quiz having atleast one student quiz submission.",
      );
      setResExcelDown(false);
    } else {
      var reqData = {
        userVO: {
          userId: userVO.userId,
          userRole: userVO.userRole,
          schoolId: userVO.schoolId,
          userRoleId: userVO.userRoleId,
          keepMeLoggedInFlag: keepMeLogIn,
          userActivityVO: {
            lastReadBookId: "",
            lastReadPageNum: "",
            lastReadChapterId: "",
            lastReadSectionId: "",
            lastReadParagraphId: "",
            lastViewedOutlineId: "",
            lastReadSubSectionId: "",
            lastActivityCode: "BOOKSHELF",
            pageNavigatingFrom: "EReader",
            pageNavigatingTo: "Bookshelf",
          },
          sessionVO: getSessionVO(),
        },
        classV: {
          classId: cqClassId,
          semesterId: cqSemId,
          timezone: excelRepoTimeZone,
          currentDate: excelRepoDateTime,
        },
        quizDetails: {
          version: cqQuizVer,
          identifier: cqIdentifier,
        },
      };
      const requestOptions = {
        method: "POST",
        body: JSON.stringify(reqData),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      };
      fetch(
        `${localStorage.getItem(
          "qpAPI",
        )}/manageProfessor/V2/getExcleResultForStudent`,
        requestOptions,
      )
        .then(handleResponse)
        .then((response) => response.blob())
        .then(handleJwtTokenForKeppMeLoggedIn)
        .then((blob) => {
          setResExcelDown(false);
          if (blob.type === "application/octet-stream") {
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement("a");
            link.href = url;
            const excelDownlDateTime = excelRepoDateTime
              .split(" ")[0]
              .replaceAll("/", "");
            link.setAttribute(
              "download",
              userVO.lastName +
                "_" +
                cqClassCode +
                "_" +
                cqProfQuNa +
                "_" +
                excelDownlDateTime +
                ".xlsx",
            );
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
          } else {
            alert("Exception Occurs. Please try again later");
          }
        })
        .catch((error) => {
          console.error(
            "There has been a problem with your fetch operation:",
            error,
          );
        });
    }
  }
  return (
    <>
      <PDFExport
        scale={0.5}
        multiPage={true}
        paperSize="letter"
        ref={pdfExportComponent}
        pageTemplate={
          previewTabActive
            ? quizPreviewReportTemplate
            : quizResultReportTemplate
        }
        margin={
          previewTabActive
            ? { top: "2cm", left: "1cm", right: "1cm", bottom: "5cm" }
            : { top: "2cm", left: "1cm", right: "1cm", bottom: "2cm" }
        }
        fileName={
          previewTabActive
            ? "Preview_" +
              cqQuizName +
              "_" +
              cqClassName +
              "_" +
              new Date().getFullYear()
            : "Results_" +
              cqQuizName +
              "_" +
              cqClassName +
              "_" +
              new Date().getFullYear()
        }
      >
        <div
          id="profCqQuizAssignment"
          className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding"
        >
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
            <div className="cqProfQuizBackBtn col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
              <button onClick={props.displayAssignment}>
                <span
                  className="fa fa-chevron-left fa-sm"
                  style={{ fontWeight: "600" }}
                ></span>
                <span style={{ paddingLeft: "4px", fontSize: "15px" }}>
                  Back to Quizzes
                </span>
              </button>
            </div>
            <div
              id="cqProfQN"
              className="cqProfQuizName col-lg-12 col-md-12 col-sm-12 col-12 no-padding"
              role="heading"
              aria-level="1"
            >
              {cqQuizName}
            </div>
            <div className="cqProfQuizClassName col-lg-12 col-md-12 col-sm-12 col-12 no-padding">
              {cqClassName}
            </div>
            {cqSemED > currentDate ? (
              <div className="cqProfQuizBtns col-lg-12 col-md-12 col-sm-12 col-12 no-padding">
                <div className="row">
                  <button
                    onClick={(e) => onClickAssignmentProps(e)}
                    className="cqProfQuizBtn"
                  >
                    {quizBtn1}
                  </button>
                  {quizBtn2 && (
                    <button
                      onClick={onClickEditAssignmentProps}
                      className="cqProfQuizEditBtn"
                    >
                      Edit Assignment Details
                    </button>
                  )}
                </div>
              </div>
            ) : null}
            {dateSE && (
              <div className="cqProfQuizDateRange col-lg-12 col-md-12 col-sm-12 col-12 no-padding">
                <p>
                  <span className="cqProfQuizStartDate">{aqStartDate}</span>
                  <span className="cqProfQuizDateBar"> | </span>
                  <span className="cqProfQuizEndDate">{aqEndDate}</span>
                </p>
              </div>
            )}
            <div className="cqProfQuizStudentDetails col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
              <ul
                className="nav nav-tabs nav-tabs-topics"
                style={{ display: "flex" }}
                role="tablist"
                aria-label={cqQuizName + " quiz options"}
              >
                <div className="no-padding">
                  <li
                    className="cqProfQuizPreviewTab"
                    role="tab"
                    aria-selected={previewTabActive === true ? true : false}
                    aria-controls="previewTabPanel"
                    id="previewTabID"
                  >
                    <button
                      className={
                        previewTabActive === true
                          ? "nav-link cqProfQuizTiltleTab active"
                          : "nav-link cqProfQuizTiltleTab"
                      }
                      onClick={handlePreviewTab}
                    >
                      Preview Quiz
                    </button>
                  </li>
                </div>
                <div className="no-padding">
                  <li
                    className="cqProfQuizStudentSimulationTab"
                    role="tab"
                    aria-selected={simuTabActive === true ? true : false}
                    aria-controls="simuTabPanel"
                    id="simuTabID"
                  >
                    <button
                      className={
                        simuTabActive === true
                          ? "nav-link cqProfQuizTiltleTab active"
                          : "nav-link cqProfQuizTiltleTab"
                      }
                      onClick={handleStudSimuTab}
                    >
                      Student Simulation
                    </button>
                  </li>
                </div>
                {resTabShown === true ? (
                  <div className="no-padding">
                    <li
                      className="cqProfQuizResultsTab"
                      role="tab"
                      aria-selected={resTabActive === true ? true : false}
                      aria-controls="resultTabPanel"
                      id="resultTabID"
                    >
                      <button
                        className={
                          resTabActive === true
                            ? "nav-link cqProfQuizTiltleTab active"
                            : "nav-link cqProfQuizTiltleTab"
                        }
                        onClick={handleViewResTab}
                      >
                        View Results
                      </button>
                    </li>
                  </div>
                ) : null}
              </ul>
            </div>
            {showQuizAssignment && (
              <CQProfessorAssignmentPopUp
                show={showQuizAssignment}
                handleQuizStatus={handleQuizStatus}
                onHide={() => setShowQuizAssignment(false)}
                data={showQuizAssignmentProps}
              />
            )}
            {showEditQuizAssignment && (
              <CQProfessorAssignmentPopUp
                show={showEditQuizAssignment}
                handleQuizStatus={handleQuizStatus}
                onHide={() => setShowEditQuizAssignment(false)}
                data={showEditQuizAssignmentProps}
              />
            )}
          </div>
          {isProfAssignLoading === false ? (
            previewTabActive === true ? (
              <>
                <div
                  className="cqProfQuizPreviewTab preview-page"
                  role="tabpanel"
                  id="previewTabPanel"
                  aria-labelledby="previewTabID"
                >
                  <div className="cqProfQuizPreviewHeader row px-3">
                    <button
                      className="cqProfQuizDownloadBtn col-xl-2 col-lg-2 col-md-2 col-sm-4 col-4 no-padding"
                      onClick={downloadQuizPreviewPdf}
                    >
                      Download
                    </button>
                    <div className="cqProfQuizPreview col-xl-10 col-lg-10 col-md-10 col-sm-8 col-8 no-padding">
                      <button
                        onClick={() => handlePrevTabExpCollpAll(true)}
                        style={{ border: "none", background: "transparent" }}
                      >
                        <span className="cqProfQuizPreviewExpandAll">
                          Expand All
                        </span>
                      </button>
                      <span className="cqProfQuizPreviewPipeLine"> | </span>
                      <button
                        onClick={() => handlePrevTabExpCollpAll(false)}
                        style={{ border: "none", background: "transparent" }}
                      >
                        <span className="cqProfQuizPreviewCollapseAll">
                          Collapse All
                        </span>
                      </button>
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
                    {previewDataQuests.map((preQues) => {
                      return (
                        <>
                          <div className="cqProfQuizPreviewDisplayBlock cqProfQuizPreviewNumberStyle col-xl-1 col-lg-1 col-md-1 col-sm-2 col-2 no-padding">
                            <span
                              className="cqProfQuizPreviewNumIndex"
                              style={
                                preQues.questionOrder > 99
                                  ? { fontSize: "25px" }
                                  : { fontSize: "35px" }
                              }
                            >
                              {preQues.questionOrder}
                            </span>
                          </div>
                          <div className="cqProfQuizPreviewBtnStyle col-xl-1 col-lg-1 col-md-1 col-sm-2 col-3 no-padding">
                            <button
                              className="cqProfQuizPreviewExpandBtn mt-2"
                              onClick={() =>
                                handlePrevTabExpCollpQues(
                                  preQues.questionOrder,
                                  preQues.ques_expand_status === true
                                    ? false
                                    : true,
                                )
                              }
                              aria-label={
                                preQues.ques_expand_status === true
                                  ? `Collapse question ${preQues.questionOrder}`
                                  : `Expand question ${preQues.questionOrder}`
                              }
                            >
                              {preQues.ques_expand_status === true
                                ? "Collapse"
                                : "Expand"}
                            </button>
                          </div>
                          <div className="cqProfQuizPreviewDisplayBlock cqProfQuizPreviewTextStyle col-xl-10 col-lg-10 col-md-9 col-sm-8 col-12 px-0 mt-xl-0 mt-lg-0 mt-md-0 mt-sm-2 mt-2 ">
                            <InnerHTML
                              html={preQues.promptText}
                              className="cqProfQuizPreviewTextStylePara"
                            />
                            {preQues.ques_expand_status === true ? (
                              <div className="cqProfQuizPreviewTabQuesDiv">
                                {preQues.choiceInteraction.simpleChoices &&
                                  preQues.choiceInteraction.simpleChoices.map(
                                    (preQuesOpt, index) => {
                                      return (
                                        <>
                                          <div
                                            key={"preQuesOpt" + index}
                                            className="col-lg-12 col-md-12 col-sm-12 col-12 no-padding"
                                          >
                                            <div
                                              className={
                                                "cqProfQuizPreviewQuestionOpts col-lg-11 col-md-11 col-sm-11 col-11 no-padding " +
                                                (preQuesOpt.correct === true
                                                  ? "cqProfQuizPreviewQuestionOptsCorr"
                                                  : "")
                                              }
                                            >
                                              <span className="d-flex flex-row">
                                                {preQuesOpt.label}
                                                <InnerHTML
                                                  html={preQuesOpt.answerText}
                                                />
                                              </span>
                                            </div>
                                            {preQuesOpt.correct === true && (
                                              <i
                                                className="fas fa-check cqProfQuizPreviewQuesCheckMark"
                                                title="Correct answer"
                                                role="img"
                                              ></i>
                                            )}
                                          </div>
                                        </>
                                      );
                                    },
                                  )}
                                <div className="display-inline-block col-lg-12 col-md-12 col-sm-12 col-12 no-padding">
                                  {preQues.rationale && (
                                    <>
                                      <div
                                        className="cqProfQuizPreviewRationalTitle"
                                        role="heading"
                                        aria-level="3"
                                      >
                                        Rationale:
                                      </div>
                                      <div className="cqProfQuizPreviewRationalContext">
                                        <InnerHTML
                                          html={
                                            preQues.rationale[0].feedbackText
                                          }
                                        />
                                      </div>
                                    </>
                                  )}
                                  {preQues.remediationLinks && (
                                    <>
                                      <div
                                        className="cqProfQuizPreviewRecommTitle"
                                        role="heading"
                                        aria-level="3"
                                      >
                                        Recommended Reading:
                                      </div>
                                      <div className="cqProfQuizPreviewRecommContext">
                                        <InnerHTML
                                          html={
                                            preQues.remediationLinks[0]
                                              .remediationlinkText
                                          }
                                        />
                                      </div>
                                    </>
                                  )}
                                  <div className="cqProfQuizPreviewRecommGroup">
                                    <div className="cqProfQuizPreviewRecommReadTitle">
                                      Additional Details (Professor Only)
                                    </div>
                                    <table className="table">
                                      <tbody>
                                        {preQues.cognitiveSkill && (
                                          <tr className="cqProfQuizPreviewRecommSkillDet">
                                            <td className="cqProfQuizPreviewRecommSkillDet">
                                              Cognitive Skill
                                            </td>
                                            <td className="cqProfQuizPreviewRecommSkillDet">
                                              <InnerHTML
                                                html={preQues.cognitiveSkill}
                                              />
                                            </td>
                                          </tr>
                                        )}
                                        {preQues.topicName && (
                                          <tr className="cqProfQuizPreviewRecommSkillDet">
                                            <td className="cqProfQuizPreviewRecommSkillDet">
                                              Topic
                                            </td>
                                            <td className="cqProfQuizPreviewRecommSkillDet">
                                              <InnerHTML
                                                html={preQues.topicName}
                                              />
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                          </div>
                          <div className="cqProfQuizPreviewQuestionsBorder"></div>
                        </>
                      );
                    })}
                  </div>
                </div>
              </>
            ) : simuTabActive === true ? (
              <>
                {showQuizResult === false ? (
                  <>
                    <Spinner
                      loading={isSummTabLoading}
                      imageSrc={loadingIcon}
                      imageStyle={{ marginTop: "20%", width: "50px" }}
                      overlayBackground="rgba(0,0,0,0)"
                    />
                    {isSummTabLoading === false && (
                      <div
                        className="container cqProfQuizSimuTab"
                        role="tabpanel"
                        id="simuTabPanel"
                        aria-labelledby="simuTabID"
                      >
                        <div className="row">
                          <div className="col-xl-3 col-lg-3 col-md-3 col-sm-7 col-7 no-padding">
                            <button
                              type="button"
                              className="mt-2 cqProfQuizSimuShowList"
                              onClick={() =>
                                setShowQuestionList(!showQuestionList)
                              }
                            >
                              {showQuestionList
                                ? `Hide Question List`
                                : `Show Question List`}
                            </button>
                            {showQuestionList ? (
                              <div className="cqProfQuizSimuQuestions pl-3 mr-4">
                                {totalUnAnsQuests === 0 ? (
                                  <div className="py-3"></div>
                                ) : (
                                  <button
                                    className="cqProfQuizSimuNext py-3"
                                    onClick={handleNextUnAnsw}
                                  >
                                    Next Unanswered
                                  </button>
                                )}
                                {quizQuests.map((ques, index) => {
                                  //Partially Answered logic below
                                  const status = getQuestionStatus(ques);
                                  return (
                                    <button
                                      data-testid={`show_question_${index}`}
                                      key={index}
                                      aria-pressed={
                                        ques.ordinal_number === currQuest
                                          ? true
                                          : false
                                      }
                                      className={
                                        status === "Unanswered"
                                          ? "cqProfQuizSimuUn pb-2"
                                          : "cqProfQuizSimu pb-2"
                                      }
                                      style={
                                        ques.ordinal_number === currQuest
                                          ? { background: "#DADADA" }
                                          : null
                                      }
                                      onClick={(event) => {
                                        setCurrQuest(ques.ordinal_number);
                                      }}
                                    >
                                      {ques.ordinal_number}: {status}
                                    </button>
                                  );
                                })}
                              </div>
                            ) : null}
                          </div>
                          <div
                            className={
                              showQuestionList
                                ? "col-xl-9 col-lg-9 col-md-9 col-sm-12 col-xs-12 no-padding cqProfQuizSimuQuestionsExpandStyle"
                                : "col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding cqProfQuizSimuQuestionsCollapseStyle"
                            }
                          >
                            <div className="row">
                              <div
                                role="status"
                                className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 pb-2"
                              >
                                <span className="cqProfQuizSimuQuestionStatus">
                                  Question:
                                </span>
                                <br></br>
                                <span className="cqProfQuizSimuQuestionDetail">
                                  {currQuest} of {totalQuests}
                                </span>
                              </div>
                              <div
                                role="status"
                                className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 pr-0"
                              >
                                <span className="cqProfQuizSimuQuestionStatus">
                                  Unanswered:
                                </span>
                                <br></br>
                                <span className="cqProfQuizSimuQuestionDetail">
                                  {totalUnAnsQuests} of {totalQuests}
                                </span>
                              </div>
                              <div
                                role="timer"
                                className="col-xl-4 col-lg-3 col-md-3 col-sm-6 col-6"
                              >
                                <span className="cqProfQuizSimuQuestionStatus">
                                  Time Spent:
                                </span>
                                <br></br>
                                <span className="cqProfQuizSimuQuestionDetail">
                                  {convertSecondsToHMS(
                                    convertHMSToSeconds() + totalQuizTime,
                                  )}
                                </span>
                              </div>
                              <div className="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-6 p-0">
                                <button
                                  className="btn cqProfQuizSimuSubmitBtn ml-xl-3 ml-lg-3 ml-md-2 ml-3"
                                  onClick={() => [
                                    pause(),
                                    setSubmitQuizPopUp(true),
                                  ]}
                                >
                                  Submit Quiz
                                </button>
                              </div>
                            </div>
                            <hr></hr>
                            <div className="row">
                              {quizQuests.map((ques) => {
                                return ques.ordinal_number === currQuest ? (
                                  <>
                                    <fieldset className="p-0 m-0 border-0">
                                      <legend className="p-0 m-0">
                                        <div
                                          id={ques.question_identifier}
                                          className="cqProfQuizSimuQuestionDesc col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                        >
                                          <InnerHTML html={ques.promptText} />
                                        </div>
                                      </legend>
                                      {/* Quiz Options*/}
                                      <QuizOptions
                                        ques={ques}
                                        regexForStripHTML={regexForStripHTML}
                                        handleSelOption={handleSelOption}
                                      />
                                    </fieldset>
                                    <div className="row col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-4 pr-0">
                                      <div
                                        className={
                                          showQuestionList
                                            ? "col-xl-3 col-lg-4 col-md-4 col-sm-12 col-12 mt-4 pr-0"
                                            : "col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 mt-4"
                                        }
                                      >
                                        <button
                                          type="button"
                                          className="btn cqProfQuizSimuOtherBtn cqProfQuizSimuOther3BtnWidth"
                                          onClick={() => {
                                            ques.SelectedAnswerList = [];
                                            handleSelOption();
                                            document
                                              .getElementById(
                                                ques.choiceInteration
                                                  .simpleChoices[0].externalId,
                                              )
                                              ?.focus();
                                          }}
                                          disabled={
                                            ques.SelectedAnswerList.filter(
                                              (id) => id !== "",
                                            )?.length === 0
                                          }
                                        >
                                          Clear Response
                                        </button>
                                      </div>
                                      <div
                                        className={
                                          showQuestionList
                                            ? "col-xl-9 col-lg-8 col-md-8 col-sm-12 col-12 mt-4 pr-2 pr-xl-0 pr-lg-0 pr-md-0 pl-xl-0 pl-lg-0 pl-md-0 pl-sm-0 pl-3 text-xl-right text-lg-right text-md-right text-sm-left text-left"
                                            : "col-xl-9 col-lg-9 col-md-8 col-sm-12 col-12 mt-4 pr-2 pr-xl-0 pr-lg-0 pr-md-0 text-xl-right text-lg-right text-md-right text-sm-left text-left"
                                        }
                                      >
                                        <div className="d-inline-flex cqProfQuizSimuOtherBtnBlockFullWidth">
                                          <button
                                            type="button"
                                            className="btn cqProfQuizSimuOtherBtn mr-xl-2 mr-lg-2 mr-md-2 mr-sm-2 mr-0"
                                            // onClick={() => [
                                            //   setCurrQuest(currQuest - 1),
                                            //   handlePrevNxtBtn(),
                                            // ]}
                                            onClick={() =>
                                              handleNavigation(ques, "previous")
                                            }
                                            disabled={
                                              currQuest === 1 ? true : false
                                            }
                                          >
                                            Previous Question
                                          </button>
                                        </div>
                                        <div className="d-inline-flex ml-xl-4 ml-lg-4 ml-md-4 ml-sm-4 ml-2 cqProfQuizSimuOtherBtnBlockMargin">
                                          <button
                                            type="button"
                                            className="btn cqProfQuizSimuOtherBtn "
                                            // onClick={() => [
                                            //   setCurrQuest(currQuest + 1),
                                            //   handlePrevNxtBtn(),
                                            // ]}
                                            onClick={() =>
                                              handleNavigation(ques, "next")
                                            }
                                            disabled={
                                              currQuest === totalQuests
                                                ? true
                                                : false
                                            }
                                          >
                                            Next Question
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="cqProfQuizSimuQuestionID row col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-4">
                                      ID: {ques.question_identifier}
                                    </div>
                                  </>
                                ) : null;
                              })}
                            </div>
                          </div>
                        </div>
                        <ConfirmDialog
                          open={dialog.open}
                          title={dialog.title}
                          text={dialog.text}
                          buttons={dialog.buttons}
                          onClose={() =>
                            setDialog((prev) => ({ ...prev, open: false }))
                          }
                        />
                        <Modal
                          className="modal fade"
                          show={submitQuizPopUp}
                          onHide={() => handleHideContactMe()}
                          size="sm"
                          aria-labelledby="contained-modal-title-unanswered"
                          centered
                        >
                          <div
                            className="cqProfQuizSimuPopUpHeader mt-4 mb-2"
                            style={{ textAlign: "center" }}
                          >
                            <div
                              aria-hidden="true"
                              className="fa fa-exclamation-circle"
                              style={
                                totalUnAnsQuests === 0
                                  ? { fontSize: "30px", color: "grey" }
                                  : { fontSize: "30px", color: "red" }
                              }
                            ></div>
                          </div>
                          <div
                            aria-label={
                              totalUnAnsQuests === 0
                                ? "Quiz submission confirmation"
                                : "Incomplete quiz submission confirmation"
                            }
                            id="contained-modal-title-unanswered"
                            className="cqProfQuizSimuPopUpBody mx-4"
                          >
                            {totalUnAnsQuests === 0 ? null : (
                              <p
                                className="cqProfQuizSimuPopUpTxt"
                                style={{ color: "#E61700" }}
                              >
                                You have {totalUnAnsQuests}{" "}
                                {totalUnAnsQuests > 1
                                  ? `questions`
                                  : `question`}{" "}
                                unanswered.
                              </p>
                            )}
                            <p className="cqProfQuizSimuPopUpTxt">
                              You will not be able to return to the quiz after
                              submitting. Are you ready to submit your quiz?
                            </p>
                          </div>
                          <div className="cqProfQuizSimuPopUpFooter">
                            <button
                              className="cqProfQuizSimuPopUpBtns mr-2"
                              onClick={() => [
                                start(),
                                setSubmitQuizPopUp(false),
                              ]}
                            >
                              No, Go Back
                            </button>
                            <button
                              ref={cqStudQuizPopUpBtnsRef}
                              className="cqProfQuizSimuPopUpBtns"
                              onClick={handleSubmitQuiz}
                            >
                              Yes, Submit
                            </button>
                          </div>
                        </Modal>
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    <Spinner
                      loading={isSummQRLoading}
                      imageSrc={loadingIcon}
                      imageStyle={{ marginTop: "20%", width: "50px" }}
                      overlayBackground="rgba(0,0,0,0)"
                    />
                    {isSummQRLoading === false && (
                      <div
                        className="row container cqProfQuizSimuResults mt-4"
                        role="tabpanel"
                        id="simuTabPanel"
                        aria-labelledby="simuTabID"
                      >
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-3">
                          <div className="cqProfQuizSimuResCard p-4">
                            <p className="cqProfQuizSimuResCardtext m-0">
                              Your Score:
                            </p>
                            <p className="cqProfQuizSimuResCardPerc m-0">
                              {Number(summQR.score).toFixed(2) + "%"}
                            </p>
                            <div className="progress cqProfQuizSimuResCardProgress">
                              <div
                                className="progress-bar cqProfQuizSimuResCardProgressBar"
                                style={{
                                  width: Number(summQR.score).toFixed(2) + "%",
                                }}
                              ></div>
                            </div>
                            <p className="cqProfQuizSimuResCardtext mt-2">
                              Class Average:
                            </p>
                            <p className="cqProfQuizSimuResCardAvgPerc m-0">
                              {Number(summQR.classAverage).toFixed(2) + "%"}
                            </p>
                            <div className="progress cqProfQuizSimuResCardAvgProgr">
                              <div
                                className="progress-bar cqProfQuizSimuResCardAvgProgrBar"
                                style={{
                                  width:
                                    Number(summQR.classAverage.toFixed(2)) +
                                    "%",
                                }}
                              ></div>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-3">
                          <div className="cqProfQuizSimuResCard p-4">
                            <p className="cqProfQuizSimuResCardtext m-0">
                              Time Spent:
                            </p>
                            <p className="cqProfQuizSimuResCardTimeSpent m-0">
                              {convertSecondsToHMS(summQR.totalTimeSpent)}
                            </p>
                            <p className="cqProfQuizSimuResCardtext my-2">
                              Date Submitted:
                            </p>
                            <p className="cqProfQuizSimuResCardAvgPerc mb-3">
                              {dateTimeConversion(summQR.completedDate)[0]}
                            </p>
                            <p className="cqProfQuizSimuResCardtext">
                              Time Submitted:
                            </p>
                            <p className="cqProfQuizSimuResCardAvgPerc m-0">
                              {dateTimeConversion(summQR.completedDate)[1]}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-3 mx-xl-0 mx-lg-0 mx-md-auto mx-sm-auto mx-0">
                          <div className="cqProfQuizSimuResCard p-4">
                            <p className="cqProfQuizSimuResCardtext m-0">
                              Questions Answered:
                            </p>
                            <p className="cqProfQuizSimuResCardAvgPerc m-0 mt-2">
                              {summQR.totalAnswered} of{" "}
                              {summQR.numberOfQuestions}
                            </p>
                            <div style={{ width: "5rem", margin: "auto" }}>
                              <QuizResultPieChart
                                nofCorr={summQR.totalCorrect}
                                nofInCorr={summQR.totalIncorrect}
                                nofUnAns={summQR.totalUnAnswered}
                                noOfPartialAnswered={summQR.PartiallyCorrect}
                              />
                            </div>
                            <p className="cqProfQuizSimuResCardPieTxt mt-2">
                              <span className="d-block">
                                {summQR.totalCorrect} Correct
                              </span>
                              <span className="d-block">
                                {summQR?.PartiallyCorrect || 0} Partially
                                Correct
                              </span>

                              <span className="d-block">
                                {summQR.totalIncorrect} Incorrect
                              </span>
                              <span>{summQR.totalUnAnswered} Unanswered</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </>
            ) : resTabActive === true ? (
              <>
                <Spinner
                  loading={isResTabStudResultsLoading}
                  imageSrc={loadingIcon}
                  imageStyle={{ marginTop: "20%", width: "50px" }}
                  overlayBackground="rgba(0,0,0,0)"
                />
                <Spinner
                  loading={resExcelDown}
                  imageSrc={loadingIcon}
                  imageStyle={{ marginTop: "20%", width: "50px" }}
                  overlayBackground="rgba(0,0,0,0.5)"
                />
                {isResTabStudResultsLoading === false && (
                  <div
                    className="cqProfQuizResultTab"
                    role="tabpanel"
                    id="resultTabPanel"
                    aria-labelledby="resultTabID"
                  >
                    <div className="cqProfQuizResultTabOverallDetails">
                      <div
                        className="cqProfQuizResultHeader col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding"
                        ref={resTabDownloadRef}
                      >
                        <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 no-padding">
                          <button
                            className="cqProfQuizDownloadBtn"
                            aria-expanded={resTabDownBtn}
                            onClick={() => [
                              setResTabDownBtn(
                                (resTabDownBtn) => !resTabDownBtn,
                              ),
                              setRefreshChart(false),
                            ]}
                          >
                            Download
                          </button>
                        </div>
                        {resTabDownBtn && (
                          <ul className="cqProfQuizResultDownloadStyles">
                            <li
                              className="cqProfQuizResultDownload"
                              onClick={downloadQuizResultPdf}
                            >
                              <span>PDF</span>
                            </li>
                            <li
                              className="cqProfQuizResultDownload"
                              onClick={downloadQuizResultExcel}
                            >
                              <span>Excel</span>
                            </li>
                          </ul>
                        )}
                      </div>
                      {quizStatus === "completed" ? (
                        <div className="cqProfQuizResultComplete col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
                          Completed: {resTabOverall.completedCount}/
                          {resTabOverall.assignedCount} Submissions
                        </div>
                      ) : (
                        <div className="cqProfQuizResultProgress col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
                          In Progress: {resTabOverall.completedCount}/
                          {resTabOverall.assignedCount} Submissions
                        </div>
                      )}
                      <div
                        className="cqProfQuizResultScoresAndTime row col-lg-12 col-md-12 col-sm-12 col-12 no-padding"
                        style={{ marginLeft: "2px" }}
                      >
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 no-padding">
                          <div
                            className="cqProfQuizResultTimeSpentDetails"
                            role="heading"
                            aria-level="2"
                          >
                            Average Time Spent:{" "}
                          </div>
                          <div className="cqProfQuizResultDetails">
                            {Number(resTabOverall.completedCount) === 0
                              ? "N/A"
                              : resTabOverall.averageTimeSpent
                                ? convertSecondsToHMS(
                                    resTabOverall.averageTimeSpent,
                                  )
                                : "N/A"}
                          </div>
                        </div>
                        <div className="cqProfQuizResultScores col-lg-6 col-md-6 col-sm-12 col-12">
                          <div className="cqProfQuizResultScoreDetails">
                            Average Score:{" "}
                          </div>
                          <div className="progress cqProfQuizResultOverallAvgProgr">
                            {resTabOverall.completedCount !== undefined &&
                            resTabOverall.avgScore !== undefined ? (
                              Number(resTabOverall.completedCount) === 0 ? (
                                <div className="progress-bar cqProfQuizResultOverallAvgProgrBarNo">
                                  No Results
                                </div>
                              ) : Number(resTabOverall.avgScore) > 0 ? (
                                <>
                                  <div
                                    className="progress-bar cqProfQuizResultOverallAvgProgrBar"
                                    style={{
                                      width:
                                        Number(resTabOverall.avgScore) + "%",
                                    }}
                                  >
                                    {Number(resTabOverall.avgScore) > 16
                                      ? Number(resTabOverall.avgScore).toFixed(
                                          2,
                                        ) + "%"
                                      : null}
                                  </div>
                                  {Number(resTabOverall.avgScore) >
                                  16 ? null : (
                                    <div className="progress-bar cqProfQuizResultOverallAvgProgrBarLess16">
                                      {Number(resTabOverall.avgScore).toFixed(
                                        2,
                                      ) + "%"}
                                    </div>
                                  )}
                                </>
                              ) : (
                                <div className="progress-bar cqProfQuizResultOverallAvgProgrBarZero">
                                  {resTabOverall.avgScore + "%"}
                                </div>
                              )
                            ) : (
                              <div className="progress-bar cqProfQuizResultOverallAvgProgrBarNo">
                                No Results
                              </div>
                            )}
                          </div>
                          <div className="cqProfQuizResultScoreDetails mt-1">
                            Lowest Score:{" "}
                          </div>
                          <div className="progress cqProfQuizResultOverallMinMaxProgr">
                            {resTabOverall.completedCount !== undefined &&
                            resTabOverall.minScore !== undefined ? (
                              Number(resTabOverall.completedCount) === 0 ? (
                                <div className="progress-bar cqProfQuizResultOverallMinMaxProgrBarNo">
                                  No Results
                                </div>
                              ) : Number(resTabOverall.minScore) > 0 ? (
                                <>
                                  <div
                                    className="progress-bar cqProfQuizResultOverallMinMaxProgrBar"
                                    style={{
                                      width:
                                        Number(resTabOverall.minScore) + "%",
                                    }}
                                  >
                                    {Number(resTabOverall.minScore) > 16
                                      ? Number(resTabOverall.minScore).toFixed(
                                          2,
                                        ) + "%"
                                      : null}
                                  </div>
                                  {Number(resTabOverall.minScore) >
                                  16 ? null : (
                                    <div className="progress-bar cqProfQuizResultOverallMinMaxProgrBarLess16">
                                      {Number(resTabOverall.minScore).toFixed(
                                        2,
                                      ) + "%"}
                                    </div>
                                  )}
                                </>
                              ) : (
                                <div className="progress-bar cqProfQuizResultOverallMinMaxProgrBarZero">
                                  {resTabOverall.minScore + "%"}
                                </div>
                              )
                            ) : (
                              <div className="progress-bar cqProfQuizResultOverallMinMaxProgrBarNo">
                                No Results
                              </div>
                            )}
                          </div>
                          <div className="cqProfQuizResultScoreDetails mt-1">
                            Highest Score:{" "}
                          </div>
                          <div className="progress cqProfQuizResultOverallMinMaxProgr">
                            {resTabOverall.completedCount !== undefined &&
                            resTabOverall.maxScore !== undefined ? (
                              Number(resTabOverall.completedCount) === 0 ? (
                                <div className="progress-bar cqProfQuizResultOverallMinMaxProgrBarNo">
                                  No Results
                                </div>
                              ) : Number(resTabOverall.maxScore) > 0 ? (
                                <>
                                  <div
                                    className="progress-bar cqProfQuizResultOverallMinMaxProgrBar"
                                    style={{
                                      width:
                                        Number(resTabOverall.maxScore) + "%",
                                    }}
                                  >
                                    {Number(resTabOverall.maxScore) > 16
                                      ? Number(resTabOverall.maxScore).toFixed(
                                          2,
                                        ) + "%"
                                      : null}
                                  </div>
                                  {Number(resTabOverall.maxScore) >
                                  16 ? null : (
                                    <div className="progress-bar cqProfQuizResultOverallMinMaxProgrBarLess16">
                                      {Number(resTabOverall.maxScore).toFixed(
                                        2,
                                      ) + "%"}
                                    </div>
                                  )}
                                </>
                              ) : (
                                <div className="progress-bar cqProfQuizResultOverallMinMaxProgrBarZero">
                                  {resTabOverall.maxScore + "%"}
                                </div>
                              )
                            ) : (
                              <div className="progress-bar cqProfQuizResultOverallMinMaxProgrBarNo">
                                No Results
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      {Number(resTabOverall.completedCount) > 0 && (
                        <div className="cqProfQuizResultOverallPerform col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
                          <div
                            className="cqProfQuizResultOverallPerformTxt col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding"
                            role="heading"
                            aria-level="2"
                            aria-hidden="true"
                          >
                            Overall Performance
                          </div>
                          <div tabIndex="0">
                            <div
                              className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding"
                              aria-hidden="true"
                            >
                              <Chart
                                style={{
                                  height: "250px",
                                }}
                                onRefresh={handleChartRefresh}
                              >
                                <ChartAxisDefaults
                                  line={{ color: "#474747" }}
                                  labels={{
                                    font: "14px Fira Sans",
                                    color: "#474747",
                                  }}
                                />
                                <ChartTooltip render={defaultTooltipRender} />
                                <ChartValueAxis>
                                  <ChartValueAxisItem
                                    majorGridLines={{
                                      visible: true,
                                      color: "#c1bbbb",
                                    }}
                                    majorTicks={{ visible: false }}
                                    title={{
                                      text: "Number of Students",
                                      font: "14px Fira Sans",
                                      color: "#474747",
                                    }}
                                    min={0}
                                    max={resTabMaxNofStuds}
                                    majorUnit={Math.ceil(resTabMaxNofStuds / 5)}
                                  />
                                </ChartValueAxis>
                                <ChartCategoryAxis>
                                  <ChartCategoryAxisItem
                                    majorGridLines={{ visible: false }}
                                    labels={{ rotation: 45 }}
                                    majorTicks={{ visible: false }}
                                    title={{
                                      text: "Scores",
                                      font: "14px Fira Sans",
                                      color: "#474747",
                                    }}
                                    categories={resTabStudentScores.scoreCat}
                                  />
                                </ChartCategoryAxis>
                                <ChartSeries>
                                  <ChartSeriesItem
                                    color="#CC7E00"
                                    data={resTabStudentScores.noOfStudent}
                                  />
                                </ChartSeries>
                              </Chart>
                            </div>
                            <table className="srOnly" aria-hidden="false">
                              <tr>
                                <th>Performance in Percentage</th>
                                <th>Number of Students</th>
                              </tr>
                              {resTabStudentScores.scoreCat.map(
                                (row, index) => (
                                  <tr>
                                    <td>{row}</td>
                                    <td>
                                      {resTabStudentScores.noOfStudent[index]}
                                    </td>
                                  </tr>
                                ),
                              )}
                            </table>
                          </div>
                        </div>
                      )}
                    </div>
                    {resTabTopicList.length > 0 &&
                    resTabQuestList.length > 0 ? (
                      <div className="cqProfQuizResultTabClassWiseDetails mt-2 no-padding">
                        <div className="row">
                          <div className="col-xl-7 col-lg-6 col-md-5 col-sm-12 col-12">
                            <div className="cqProfQuizResultTitleContainer col-xl-7 col-lg-8 col-md-12 col-sm-12 col-12">
                              <h2 className="cqProfQuizResultTitle">
                                Class Results
                              </h2>
                            </div>
                          </div>
                          <div className="col-xl-5 col-lg-6 col-md-7 col-sm-12 col-12">
                            <div className="cqProfQuizResultSortByPadding row">
                              <div className="cqProfQuizResultViewingLabel col-xl-4 col-lg-4 col-md-3 col-sm-3 col-3">
                                <p
                                  className="cqProfQuizResultSortBY text-xl-right text-lg-right text-md-right text-sm-left text-left pl-2"
                                  style={{ paddingTop: "4px" }}
                                >
                                  Sort By:
                                </p>
                              </div>
                              <div
                                className="col-xl-8 col-lg-8 col-md-9 col-sm-9 col-9 pl-xl-3 pl-lg-3 pl-md-2 pl-sm-0 pl-0"
                                style={{ paddingRight: "9px" }}
                              >
                                <select
                                  data-testid="select_class_results"
                                  aria-label="Sort by"
                                  className="cqProfQuizResultSortBySelect"
                                  value={resTabClassResultView}
                                  onChange={(e) =>
                                    updateClassResultView(e.target.value)
                                  }
                                >
                                  <option value="topicView">
                                    Topic Performance
                                  </option>
                                  <option value="questionView">
                                    Quiz Question Order
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                        {resTabClassResultView === "topicView" ? (
                          <div className="row border-bottom pb-2 mb-2">
                            <div className="col">
                              {resTabTopicList.map((topicData) => {
                                return (
                                  <>
                                    <div className="cqProfQuizResultStudNames">
                                      {topicData.value}
                                    </div>
                                    <div className="progress cqProfQuizResultClassProgr">
                                      {topicData.classAverage > 0 ? (
                                        <>
                                          <div
                                            className="progress-bar cqProfQuizResultClassProgrBar"
                                            style={{
                                              width:
                                                topicData.classAverage + "%",
                                            }}
                                          >
                                            {topicData.classAverage > 16
                                              ? topicData.classAverage + "%"
                                              : null}
                                          </div>
                                          {topicData.classAverage >
                                          16 ? null : (
                                            <div className="progress-bar cqProfQuizResultClassProgrBarLess16">
                                              {topicData.classAverage + "%"}
                                            </div>
                                          )}
                                        </>
                                      ) : (
                                        <div className="progress-bar cqProfQuizResultClassProgrBarNo">
                                          {topicData.classAverage + "%"}
                                        </div>
                                      )}
                                    </div>
                                    <div className="cqProfQuizResultTopicExp mb-2">
                                      <button
                                        onClick={() =>
                                          handleTopicListExpand(
                                            topicData.value,
                                            topicData.topic_expand_status ===
                                              true
                                              ? false
                                              : true,
                                          )
                                        }
                                      >
                                        {topicData.topic_expand_status === true
                                          ? "Collapse question breakdown"
                                          : "Expand question breakdown"}
                                      </button>
                                    </div>
                                    {topicData.topic_expand_status === true ? (
                                      <div className="card card-body pl-xl-3 pl-lg-3 pl-md-3 pl-sm-0 pl-0">
                                        <ol
                                          className="m-0 p-0"
                                          style={{ listStyleType: "none" }}
                                        >
                                          {topicData.associatedQuestionVOList.map(
                                            (topicListQues, index) => {
                                              return (
                                                <li key={index}>
                                                  <div
                                                    data-testid={`topic_question_${topicListQues.ordinalNumber}`}
                                                    tabIndex={0}
                                                    role="button"
                                                    className="cqProfQuizResultQuizzesTxt row mb-2"
                                                    onClick={() =>
                                                      handleTopicQuesListExpand(
                                                        topicData.value,
                                                        topicListQues.ordinalNumber,
                                                        topicListQues.topicQues_expand_status ===
                                                          true
                                                          ? false
                                                          : true,
                                                      )
                                                    }
                                                    onKeyDown={(e) => {
                                                      if (e.key === "Enter") {
                                                        handleTopicQuesListExpand(
                                                          topicData.value,
                                                          topicListQues.ordinalNumber,
                                                          topicListQues.topicQues_expand_status ===
                                                            true
                                                            ? false
                                                            : true,
                                                        );
                                                      }
                                                    }}
                                                    aria-expanded={
                                                      topicListQues.topicQues_expand_status ===
                                                      true
                                                        ? true
                                                        : false
                                                    }
                                                    aria-disabled={
                                                      topicListQues.topicQues_expand_status ===
                                                      true
                                                        ? true
                                                        : false
                                                    }
                                                  >
                                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                      <div
                                                        className="cqProfQuizPreviewDisplayBlock col-xl-1 col-lg-1 col-md-1 col-sm-2 col-2 pl-xl-3 pl-lg-2 pl-md-2 pl-0 pr-0"
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                      >
                                                        {topicListQues.ordinalNumber +
                                                          ". "}
                                                      </div>
                                                      <div
                                                        className="col-xl-1 col-lg-2 col-md-2 col-sm-4 col-4 no-padding float-right"
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                      >
                                                        <span className="cqProfQuizResultAnsTxt">
                                                          <i
                                                            className="fas fa-check cqProfQuizResultCheckIcon"
                                                            title="Correct answer"
                                                            role="img"
                                                          ></i>
                                                          <span>
                                                            {topicListQues.correctPercentage +
                                                              "%"}
                                                          </span>
                                                        </span>
                                                      </div>
                                                      <InnerHTML
                                                        html={
                                                          topicListQues.promptText
                                                        }
                                                        className={
                                                          topicListQues.topicQues_expand_status ===
                                                          true
                                                            ? "cqProfQuizResultQuesTxtExpa cqProfQuizResultQuesTxtMar col-xl-10 col-lg-9 col-md-9 col-sm-12 col-12 p-0 d-inline-block px-0 mt-xl-0 mt-lg-0 mt-md-0 mt-sm-2 mt-2 pl-xl-0 pl-lg-0 pl-md-0 pl-2"
                                                            : "cqProfQuizResultQuesTxtShort cqProfQuizResultQuesTxtMar col-xl-10 col-lg-9 col-md-9 col-sm-6 col-6 p-0 d-inline-block px-0 mt-0"
                                                        }
                                                      />
                                                    </div>
                                                    {topicListQues.topicQues_expand_status ===
                                                    true ? (
                                                      <div
                                                        className="border-bottom mt-2 w-100"
                                                        style={{
                                                          marginLeft: "10%",
                                                        }}
                                                      >
                                                        {topicListQues.choiceInteraction.simpleChoices.map(
                                                          (
                                                            topicListQuesOpt,
                                                          ) => {
                                                            return (
                                                              <>
                                                                <div className="row">
                                                                  <div className="col-10 p-1">
                                                                    <p className="cqProfQuizResultOptionText p-2 mt-2">
                                                                      <span className="cqProfQuizResultText d-flex flex-row">
                                                                        {
                                                                          topicListQuesOpt.label
                                                                        }
                                                                        <InnerHTML
                                                                          html={
                                                                            topicListQuesOpt.answerText
                                                                          }
                                                                        />
                                                                      </span>
                                                                    </p>
                                                                  </div>
                                                                  <div className="col-2 p-0 pt-4">
                                                                    {topicListQuesOpt.correct ===
                                                                    true ? (
                                                                      <span className="cqProfQuizResultAnsTxt">
                                                                        <i
                                                                          className="fas fa-check cqProfQuizResultCheckIcon"
                                                                          title="Correct answer"
                                                                          role="img"
                                                                        ></i>
                                                                        <span>
                                                                          {topicListQuesOpt.userResponsePercentage +
                                                                            "%"}
                                                                        </span>
                                                                      </span>
                                                                    ) : (
                                                                      <span className="cqProfQuizResultAnsTxt">
                                                                        <span>
                                                                          {topicListQuesOpt.userResponsePercentage +
                                                                            "%"}
                                                                        </span>
                                                                      </span>
                                                                    )}
                                                                  </div>
                                                                </div>
                                                              </>
                                                            );
                                                          },
                                                        )}
                                                        <div className="ml-3">
                                                          {topicListQues.feedbackText !==
                                                          undefined ? (
                                                            <>
                                                              <p
                                                                className="cqProfQuizResultQuizzesTxt"
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                                role="heading"
                                                                aria-level="3"
                                                              >
                                                                {" "}
                                                                Rationale:
                                                              </p>
                                                              <p
                                                                id="cqProfQuizTopicRationaleTxt"
                                                                className="cqProfQuizResultQuizzesTxt"
                                                              >
                                                                <InnerHTML
                                                                  html={
                                                                    topicListQues.feedbackText
                                                                  }
                                                                />
                                                              </p>
                                                            </>
                                                          ) : null}
                                                          {topicListQues.remediationLinks !==
                                                          undefined ? (
                                                            <>
                                                              <p
                                                                className="cqProfQuizResultQuizzesTxt"
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                                role="heading"
                                                                aria-level="3"
                                                              >
                                                                Recommended
                                                                Reading:
                                                              </p>
                                                              <p className="cqProfQuizResultQuizzesTxt">
                                                                <InnerHTML
                                                                  html={
                                                                    topicListQues
                                                                      .remediationLinks[0]
                                                                      .remediationlinkText
                                                                  }
                                                                />
                                                              </p>
                                                            </>
                                                          ) : null}
                                                          {topicListQues.topicName !==
                                                          undefined ? (
                                                            <>
                                                              <p
                                                                className="cqProfQuizResultQuizzesTxt"
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                                role="heading"
                                                                aria-level="3"
                                                              >
                                                                Topic:
                                                              </p>
                                                              <p className="cqProfQuizResultQuizzesTxt">
                                                                <InnerHTML
                                                                  html={
                                                                    topicListQues.topicName
                                                                  }
                                                                />
                                                              </p>
                                                            </>
                                                          ) : null}
                                                        </div>
                                                      </div>
                                                    ) : null}
                                                  </div>
                                                </li>
                                              );
                                            },
                                          )}
                                        </ol>
                                      </div>
                                    ) : null}
                                  </>
                                );
                              })}
                            </div>
                          </div>
                        ) : (
                          <div className="card card-body pl-xl-3 pl-lg-3 pl-md-3 pl-sm-0 pl-0">
                            <ol
                              className="m-0 p-0"
                              style={{ listStyleType: "none" }}
                            >
                              {resTabQuestList.map((quesListQues, index) => {
                                return (
                                  <li key={index}>
                                    <div
                                      data-testid={`class_result_${quesListQues.ordinalNumber}`}
                                      tabIndex={0}
                                      className="cqProfQuizResultQuizzesTxt row mb-2"
                                      role="heading"
                                      aria-expanded={
                                        quesListQues.orderQues_expand_status ===
                                        true
                                          ? true
                                          : false
                                      }
                                      aria-disabled={
                                        quesListQues.orderQues_expand_status ===
                                        true
                                          ? true
                                          : false
                                      }
                                      onClick={() =>
                                        handleQuesListQuesExpand(
                                          quesListQues.ordinalNumber,
                                          quesListQues.orderQues_expand_status ===
                                            true
                                            ? false
                                            : true,
                                        )
                                      }
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                          handleQuesListQuesExpand(
                                            quesListQues.ordinalNumber,
                                            quesListQues.orderQues_expand_status ===
                                              true
                                              ? false
                                              : true,
                                          );
                                        }
                                      }}
                                    >
                                      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                        <div
                                          className="col-xl-1 col-lg-1 col-md-1 col-sm-2 col-2 pl-xl-3 pl-lg-2 pl-md-2 pl-0 pr-0 cqProfQuizPreviewDisplayBlock"
                                          style={{ cursor: "pointer" }}
                                        >
                                          {quesListQues.ordinalNumber + ". "}
                                        </div>
                                        <div
                                          className="col-xl-1 col-lg-2 col-md-2 col-sm-4 col-4 no-padding float-right"
                                          style={{ cursor: "pointer" }}
                                        >
                                          <span className="cqProfQuizResultAnsTxt">
                                            <i
                                              className="fas fa-check cqProfQuizResultCheckIcon"
                                              title="Correct answer"
                                              role="img"
                                            ></i>
                                            <span>
                                              {quesListQues.correctPercentage +
                                                "%"}
                                            </span>
                                          </span>
                                        </div>
                                        <InnerHTML
                                          html={quesListQues.promptText}
                                          className={
                                            quesListQues.orderQues_expand_status ===
                                            true
                                              ? "cqProfQuizResultQuesTxtExpa cqProfQuizResultQuesTxtMar col-xl-10 col-lg-9 col-md-9 col-sm-12 col-12 p-0 d-inline-block px-0 mt-xl-0 mt-lg-0 mt-md-0 mt-sm-2 mt-2 pl-xl-0 pl-lg-0 pl-md-0 pl-2"
                                              : "cqProfQuizResultQuesTxtShort cqProfQuizResultQuesTxtMar col-xl-10 col-lg-9 col-md-9 col-sm-6 col-6 p-0 d-inline-block px-0 mt-0"
                                          }
                                        />
                                      </div>
                                      {quesListQues.orderQues_expand_status ===
                                      true ? (
                                        <div
                                          className="border-bottom mt-2 w-100"
                                          style={{ marginLeft: "10%" }}
                                        >
                                          {quesListQues.choiceInteraction.simpleChoices.map(
                                            (quesListQuesOpt) => {
                                              return (
                                                <>
                                                  <div className="row">
                                                    <div className="col-10 p-1">
                                                      <p className="cqProfQuizResultOptionText p-2 mt-2">
                                                        <span className="cqProfQuizResultText d-flex flex-row">
                                                          {
                                                            quesListQuesOpt.label
                                                          }
                                                          <InnerHTML
                                                            html={
                                                              quesListQuesOpt.answerText
                                                            }
                                                          />
                                                        </span>
                                                      </p>
                                                    </div>
                                                    <div className="col-2 p-0 pt-4">
                                                      {quesListQuesOpt.correct ===
                                                      true ? (
                                                        <span className="cqProfQuizResultAnsTxt">
                                                          <i
                                                            className="fas fa-check cqProfQuizResultCheckIcon"
                                                            title="Correct answer"
                                                            role="img"
                                                          ></i>
                                                          <span>
                                                            {quesListQuesOpt.userResponsePercentage +
                                                              "%"}
                                                          </span>
                                                        </span>
                                                      ) : (
                                                        <span className="cqProfQuizResultAnsTxt">
                                                          <span>
                                                            {quesListQuesOpt.userResponsePercentage +
                                                              "%"}
                                                          </span>
                                                        </span>
                                                      )}
                                                    </div>
                                                  </div>
                                                </>
                                              );
                                            },
                                          )}
                                          <div className="ml-3">
                                            {quesListQues.feedbackText !==
                                            undefined ? (
                                              <>
                                                <p
                                                  className="cqProfQuizResultQuizzesTxt"
                                                  style={{ fontWeight: "bold" }}
                                                  role="heading"
                                                  aria-level="3"
                                                >
                                                  {" "}
                                                  Rationale:
                                                </p>
                                                <p
                                                  id="cqProfQuizTopicRationaleTxt"
                                                  className="cqProfQuizResultQuizzesTxt"
                                                >
                                                  <InnerHTML
                                                    html={
                                                      quesListQues.feedbackText
                                                    }
                                                  />
                                                </p>
                                              </>
                                            ) : null}
                                            {quesListQues.remediationLinks !==
                                            undefined ? (
                                              <>
                                                <p
                                                  className="cqProfQuizResultQuizzesTxt"
                                                  style={{ fontWeight: "bold" }}
                                                  role="heading"
                                                  aria-level="3"
                                                >
                                                  Recommended Reading:
                                                </p>
                                                <p className="cqProfQuizResultQuizzesTxt">
                                                  <InnerHTML
                                                    html={
                                                      quesListQues
                                                        .remediationLinks[0]
                                                        .remediationlinkText
                                                    }
                                                  />
                                                </p>
                                              </>
                                            ) : null}
                                            {quesListQues.topicName !==
                                            undefined ? (
                                              <>
                                                <p
                                                  className="cqProfQuizResultQuizzesTxt"
                                                  style={{ fontWeight: "bold" }}
                                                  role="heading"
                                                  aria-level="3"
                                                >
                                                  Topic:
                                                </p>
                                                <p className="cqProfQuizResultQuizzesTxt">
                                                  <InnerHTML
                                                    html={
                                                      quesListQues.topicName
                                                    }
                                                  />
                                                </p>
                                              </>
                                            ) : null}
                                          </div>
                                        </div>
                                      ) : null}
                                    </div>
                                  </li>
                                );
                              })}
                            </ol>
                          </div>
                        )}
                      </div>
                    ) : null}
                    {lowestStudList.length > 0 ? (
                      <div className="cqProfQuizResultStudentWiseDetails no-padding">
                        <div className="row">
                          <div className="col-xl-7 col-lg-6 col-md-5 col-sm-12 col-12">
                            <div className="cqProfQuizResultTitleContainer col-xl-7 col-lg-8 col-md-12 col-sm-12 col-12">
                              <h2 className="cqProfQuizResultTitle">
                                Detailed Student Results
                              </h2>
                            </div>
                            {resTabClassType === "anonymous" ? (
                              <div className="cqProfQuizResultAnonyMsg col-xl-7 col-lg-8 col-md-12 col-sm-12 col-12 no-padding">
                                Students' results are anonymous
                              </div>
                            ) : null}
                          </div>
                          <div className="col-xl-5 col-lg-6 col-md-7 col-sm-12 col-12">
                            <div className="cqProfQuizResultSortByPadding row">
                              <div className="cqProfQuizResultViewingLabel col-xl-4 col-lg-4 col-md-3 col-sm-3 col-3">
                                <p
                                  className="cqProfQuizResultSortBY text-xl-right text-lg-right text-md-right text-sm-left text-left pl-2"
                                  style={{ paddingTop: "4px" }}
                                >
                                  Sort By:
                                </p>
                              </div>
                              <div
                                className="col-xl-8 col-lg-8 col-md-9 col-sm-9 col-9 pl-xl-3 pl-lg-3 pl-md-2 pl-sm-0 pl-0"
                                style={{ paddingRight: "9px" }}
                              >
                                <select
                                  data-testid="select_student_result"
                                  aria-label="Sort by"
                                  className="cqProfQuizResultSortBySelect"
                                  value={resTabStudentResultView}
                                  onChange={(e) =>
                                    handleUpdateStudResView(e.target.value)
                                  }
                                >
                                  <option value="lowestPerformance">
                                    Lowest Performance
                                  </option>
                                  <option value="highestPerformance">
                                    Highest Performance
                                  </option>
                                  <option value="alphabeticalOrder">
                                    Alphabetical Last Name
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row border-bottom pb-2 mb-2">
                          <div className="col">
                            {lowestStudList.map((studData) => {
                              return (
                                <>
                                  <div className="row">
                                    <div className="cqProfQuizResultStudNames col-xl-5 col-lg-4 col-md-12 col-sm-12 col-12">
                                      {resTabClassType === "anonymous"
                                        ? studData.firstName !== undefined
                                          ? studData.firstName
                                          : "Student has not entered ID"
                                        : studData.firstName +
                                          " " +
                                          studData.lastName}
                                    </div>
                                    <div className="cqProfQuizResultStudTimeSpent col-xl-7 col-lg-8 col-md-12 col-sm-12 col-12 text-lg-right text-md-right text-sm-left text-left">
                                      {studData.instanceId !== 0 ? (
                                        <span>
                                          Submitted:{" "}
                                          <b>
                                            {studSubmitDateTimeModification(
                                              studData.completedDate,
                                            )}
                                          </b>{" "}
                                          | Time Spent:{" "}
                                          <b>
                                            {convertSecondsToHMS(
                                              studData.timeSpent,
                                            )}
                                          </b>
                                        </span>
                                      ) : null}
                                    </div>
                                  </div>
                                  <div className="progress cqProfQuizResultStudProgr">
                                    {studData.instanceId === 0 ? (
                                      <div className="progress-bar cqProfQuizResultStudProgrBarNo">
                                        Not Submitted
                                      </div>
                                    ) : Number(studData.score) > 0 ? (
                                      <>
                                        <div
                                          className="progress-bar cqProfQuizResultStudProgrBar"
                                          style={{
                                            width: Number(studData.score) + "%",
                                          }}
                                        >
                                          {Number(studData.score) > 16
                                            ? Number(studData.score).toFixed(
                                                2,
                                              ) + "%"
                                            : null}
                                        </div>
                                        {Number(studData.score) > 16 ? null : (
                                          <div className="progress-bar cqProfQuizResultStudProgrBarLess16">
                                            {Number(studData.score).toFixed(2) +
                                              "%"}
                                          </div>
                                        )}
                                      </>
                                    ) : (
                                      <div className="progress-bar cqProfQuizResultStudProgrBarZero">
                                        {studData.score + "%"}
                                      </div>
                                    )}
                                  </div>
                                  <div className="cqProfQuizResultTopicExp mb-2">
                                    {studData.instanceId !== 0 ? (
                                      <button
                                        onClick={() =>
                                          handleStudResultExpand(
                                            studData.userId,
                                            studData.studTopic_expand_status ===
                                              true
                                              ? false
                                              : true,
                                          )
                                        }
                                      >
                                        {studData.studTopic_expand_status ===
                                        true
                                          ? "Collapse results"
                                          : "Expand results"}
                                      </button>
                                    ) : null}
                                  </div>

                                  <div className="cqProfQuizResultTopicExpTxt col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
                                    {resTabClassResultView === "topicView"
                                      ? studData.studTopic_expand_status ===
                                          true &&
                                        studData.topicVOList &&
                                        studData.topicVOList.map(
                                          (topicStudData, tIdx) => (
                                            <React.Fragment key={tIdx}>
                                              {/* Topic Name */}
                                              <div className="cqProfQuizResultStudNames col-lg-12 col-md-12 col-sm-12 col-12 no-padding">
                                                {topicStudData.value}
                                              </div>

                                              {/* Progress Bar */}
                                              <div className="progress cqProfQuizResultStudResProgr col-lg-12 col-md-12 col-sm-12 col-12 no-padding">
                                                {topicStudData.correctPercentage >
                                                0 ? (
                                                  <>
                                                    <div
                                                      className="progress-bar cqProfQuizResultStudResProgrBar"
                                                      style={{
                                                        width:
                                                          topicStudData.correctPercentage +
                                                          "%",
                                                      }}
                                                    >
                                                      {topicStudData.correctPercentage >
                                                      16
                                                        ? topicStudData.correctPercentage +
                                                          "%"
                                                        : null}
                                                    </div>
                                                    {topicStudData.correctPercentage <=
                                                      16 && (
                                                      <div className="progress-bar cqProfQuizResultStudResProgrBarLess16">
                                                        {topicStudData.correctPercentage +
                                                          "%"}
                                                      </div>
                                                    )}
                                                  </>
                                                ) : (
                                                  <div className="progress-bar cqProfQuizResultStudResProgrBarNo">
                                                    {topicStudData.correctPercentage +
                                                      "%"}
                                                  </div>
                                                )}
                                              </div>

                                              {/* Questions */}
                                              <div className="card card-body">
                                                <ol
                                                  className="m-0 p-0"
                                                  style={{
                                                    listStyleType: "none",
                                                  }}
                                                >
                                                  {topicStudData.associatedQuestionVOList?.map(
                                                    (ques, qIdx) => (
                                                      <li key={qIdx}>
                                                        <div className="cqProfQuizResultQuizzesTxt row mb-2">
                                                          <div className="cqProfQuizResultQuesExpDiv col-12">
                                                            <div className="cqProfQuizPreviewDisplayBlock col-xl-1 col-lg-1 col-md-1 col-sm-2 col-2 pl-xl-3 pl-lg-2 pl-md-2 pl-0 pr-0">
                                                              {ques.ordinalNumber +
                                                                ". "}
                                                            </div>

                                                            <InnerHTML
                                                              html={
                                                                ques.promptText
                                                              }
                                                              className="cqProfQuizResultQuesTxtShort cqProfQuizResultQuesTxtMar col-xl-9 col-lg-9 col-md-9 col-sm-6 col-6 p-0 d-inline-block px-0 mt-0"
                                                            />

                                                            <div className="col-xl-2 col-lg-2 col-md-2 col-sm-4 col-4 no-padding float-right">
                                                              <RenderAnswers
                                                                question={ques}
                                                              />
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </li>
                                                    ),
                                                  )}
                                                </ol>
                                              </div>

                                              <div className="cqProfQuizResultStudBorder col-xl-11 col-lg-12 col-md-12 col-sm-12 col-12 mb-3"></div>
                                            </React.Fragment>
                                          ),
                                        )
                                      : studData.studTopic_expand_status ===
                                          true &&
                                        studData.questionVOList && (
                                          <>
                                            {studData.questionVOList.map(
                                              (ques, idx) => (
                                                <div
                                                  key={idx}
                                                  className="card card-body"
                                                >
                                                  <div className="cqProfQuizResultQuizzesTxt row">
                                                    <div className="cqProfQuizResultQuesExpDiv col-12">
                                                      <div className="cqProfQuizPreviewDisplayBlock col-xl-1 col-lg-1 col-md-1 col-sm-2 col-2 pl-xl-3 pl-lg-2 pl-md-2 pl-0 pr-0">
                                                        {ques.ordinalNumber +
                                                          ". "}
                                                      </div>

                                                      <InnerHTML
                                                        html={ques.promptText}
                                                        className="cqProfQuizResultQuesTxtShort cqProfQuizResultQuesTxtMar col-xl-9 col-lg-9 col-md-9 col-sm-6 col-6 p-0 d-inline-block px-0 mt-0"
                                                      />

                                                      <div className="col-xl-2 col-lg-2 col-md-2 col-sm-4 col-4 no-padding float-right">
                                                        <RenderAnswers
                                                          question={ques}
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              ),
                                            )}

                                            <div className="cqProfQuizResultStudBorder col-xl-11 col-lg-10 col-md-12 col-sm-12 col-12 mb-3"></div>
                                          </>
                                        )}
                                  </div>
                                </>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                )}
              </>
            ) : null
          ) : null}
        </div>
      </PDFExport>
    </>
  );
}
